import React from "react";
import { Card } from "reactstrap";

import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import GuestFormButton from "./GuestFormButton";

const GuestListItem = ({ item, LoadData }) => {
  return (
    <Colxx xxs="12">
      <Card className="d-flex flex-row mb-3">
        <div className="pl-2 d-flex flex-grow-1 min-width-zero col-12">
          <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.firstName} {item.lastName}</b>
            </p>
            <p className="mb-1  text-small w-15 w-sm-100">
              <b>{item.roomNumber}</b>
            </p>
            <p className="mb-1 text-muted text-small w-35 w-sm-100">
              {item.dates}
            </p>
            <p className="mb-1 text-muted text-small w-20 w-sm-100">
              Adults: {item.adults}  Children: {item.children}
            </p>
            <div className="w-15 w-sm-100">
              <GuestFormButton
                id={item.id}
                LoadData={LoadData}
              >
              </GuestFormButton>
            </div>
          </div>
        </div>
      </Card>
    </Colxx>
  );
};

export default React.memo(GuestListItem);
